/**
 * @generated SignedSource<<5d43611f2d5cf629b1527f60215f5fdb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnfollowUserInput = {
  userId: string;
};
export type UserFollowButtonUnfollowMutation$variables = {
  input: UnfollowUserInput;
};
export type UserFollowButtonUnfollowMutation$data = {
  readonly unfollowUser: {
    readonly user: {
      readonly id: string;
      readonly viewerIsFollowing: boolean;
      readonly followers: {
        readonly pageInfo: {
          readonly total: number;
        };
      };
    } | null;
  } | null;
};
export type UserFollowButtonUnfollowMutation = {
  variables: UserFollowButtonUnfollowMutation$variables;
  response: UserFollowButtonUnfollowMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnfollowUserPayload",
    "kind": "LinkedField",
    "name": "unfollowUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerIsFollowing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              }
            ],
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "followers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "followers(first:1)"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserFollowButtonUnfollowMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserFollowButtonUnfollowMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5acf9ceb7825431ad38fd10a59d993df",
    "id": null,
    "metadata": {},
    "name": "UserFollowButtonUnfollowMutation",
    "operationKind": "mutation",
    "text": "mutation UserFollowButtonUnfollowMutation(\n  $input: UnfollowUserInput!\n) {\n  unfollowUser(input: $input) {\n    user {\n      id\n      viewerIsFollowing\n      followers(first: 1) {\n        pageInfo {\n          total\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8ec0ba399d1780516d097115f167b247";

export default node;
